import { useSelector } from 'react-redux'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import LoadingIndicator from '../../components/LoadingIndicator'

const MilitaryOccupationComparison = props => {
  const { error, fluidContainer = false } = props
  const comparisons = useSelector(
    state => state.military.comparisonResponse.result?.comparisons
  )

  if (!comparisons) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  if (error) {
    return (
      <div className="container">
        <div className="alert alert-warning" role="alert">
          <h3>{error}</h3>
        </div>
      </div>
    )
  }

  return (
    <div className={fluidContainer ? 'container-fluid' : 'container'}>
      <table id="comparison" className="tbl">
        <thead>
          <tr>
            <th className="comparison-heading">
              <span className="sr-only">{t`Comparison Attribute`}</span>
            </th>
            {(comparisons || []).map((data, idx) => (
              <th key={`comparison${idx}`} className="occupation-title">
                <Link
                  to={data?.url}
                  style={{ fontWeight: 'bold' }}
                  className="occupation-link regular-match">
                  {data?.title}
                </Link>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Branch of Service`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`service${idx}`} className="occupation-title">
                {data?.branchOfService}
              </td>
            ))}
          </tr>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Code`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`code${idx}`} className="occupation-title">
                {data?.moc}
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Type`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`type${idx}`} className="occupation-title">
                {data?.types}
              </td>
            ))}
          </tr>

          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Civilian Occupations`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`civilian${idx}`} className="possible-occs vatop">
                <ul className="fa-ul">
                  {data?.onetSoc?.map((occ, idx2) => (
                    <li key={`occ${idx2}`}>
                      <i aria-hidden="true" className="fa-li fal fa-briefcase"></i>
                      <Link to={occ.url} className="occupation-link regular-match title">
                        {occ.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Lay titles`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`laytitle${idx}`} className="possible-occs vatop">
                <ul className="fa-ul">
                  {data?.layTitles?.map(o => (
                    <li>{o}</li>
                  ))}
                </ul>
              </td>
            ))}
          </tr>
        </tbody>
        <tfoot>
          <tr className="even">
            <th></th>
            {(comparisons || []).map((data, idx) => (
              <th className="profile-link" key={`comparison${idx}`}>
                <Link to={data?.url} className="submit">
                  {t`View Profile`}
                </Link>
              </th>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export { MilitaryOccupationComparison }
